import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getAgrotechnicalEventsList.success: {
            return action.payload;
        }

        case constants.getAgrotechnicalEventsList.error: {
            return initialState;
        }

        default:
            return state;
    }
}